import React from "react";

type ProfileImageProps = {
  color?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  borderOutlineColor?: string;
};

const SlothProfileSolo = ({ color, width, height, style, borderOutlineColor }: ProfileImageProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="-2 -2 184 184"
    fill="none"
    style={style}
  >
    <g clipPath="url(#clip0_446_371)">
      <path
        d="M90 179C139.1533 179 179 139.1533 179 90C179 40.8467 139.1533 1 90 1C40.8467 1 1 40.8467 1 90C1 139.1533 40.8467 179 90 179Z"
        fill="var(--jungle-art-avatar-disc, #FBFFDF)"
        stroke={borderOutlineColor}
        strokeWidth={borderOutlineColor ? 1 : 0}
      />
      <mask
        id="mask0_446_371"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="180"
        height="180"
      >
        <path
          d="M90 179C139.1533 179 179 139.1533 179 90C179 40.8467 139.1533 1 90 1C40.8467 1 1 40.8467 1 90C1 139.1533 40.8467 179 90 179Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_446_371)">
        <path
          d="M167.95 192.66C168.45 192.99 168.93 192.16 168.96 191.57C169.28 185.47 166.4 179.68 163.33 174.41C158.18 165.56 152.34 157.13 145.93 149.14C144.36 147.19 142.74 145.27 140.73 143.79C139.28 142.73 134.14 134.89 132.36 134.8C130.58 134.71 132.01 141.77 131.35 143.77C130.83 145.33 130.43 146.91 130.63 148.54C132.08 160.22 130.74 172.45 133.87 183.8C134.17 184.83 134.46 185.9 135.08 186.79C136.41 188.68 138.81 189.42 141.05 190.04C146.34 191.52 151.63 192.97 156.9 194.45C159.09 195.07 161.31 195.66 163.58 195.6C165.85 195.54 166.57 194.51 167.96 192.7V192.67L167.95 192.66Z"
          fill="#894C0A"
        />
        <path
          d="M161.47 175.91C163.86 175.91 166.01 177.09 167.55 178.92C168.19 179.68 169.33 180.31 169.72 181.35C169.96 181.97 169.84 182.77 169.31 183.15C168.72 183.56 167.89 183.36 167.18 183.42C166.03 182.09 164.4 181.23 163.07 180.08C162.54 179.61 162.04 179.07 161.74 178.42C161.53 177.92 161.44 177.39 161.39 176.85C161.33 176.5 161.48 176.26 161.45 175.9H161.48L161.47 175.91Z"
          fill="#894C0A"
        />
        <path
          d="M169.25 191.56C169.4 188.75 168.84 186 167.92 183.37C168.45 183.37 168.95 183.46 169.4 183.1C169.93 182.69 170.05 181.92 169.81 181.3C169.57 180.68 169.07 180.21 168.57 179.76C167.56 178.93 166.5 178.19 165.38 177.54C164.97 176.74 164.29 175.56 163.84 174.76C161.68 175.09 159.7 175.56 157.75 176.71C156.63 177.39 155.59 178.22 154.7 179.16C151.8 182.23 150.53 186.91 150.59 191.13C150.59 191.6 150.65 192.11 150.71 192.58C152.87 193.17 155.03 193.79 157.18 194.41C159.37 195.03 161.61 195.62 163.86 195.56C166.11 195.5 166.82 194.47 168.21 192.66C168.71 192.99 169.22 192.16 169.24 191.54L169.25 191.56Z"
          fill="#894C0A"
        />
        <path
          d="M124.6 117.18C131.07 125.19 135.63 142.64 138.5 152.51C143.35 169.27 143.14 168.65 147.07 195.62C148.02 202.15 146.77 224.21 147.37 230.77C148.35 241.65 149.06 253.59 142.64 262.46C139.12 267.34 133.77 270.65 128.06 272.6C122.35 274.55 116.32 275.17 110.32 275.44C92.4 276.27 74.34 274.14 57.1 269.08C47.37 266.24 31.7 262.66 25.29 254.83C21.03 249.66 15.53 244.16 15.53 237.42C15.53 230.68 15.97 225.36 16.33 218.65C17.36 199.17 19.14 196.48 24.31 177.91C26.62 169.63 30.37 147.22 32.2 138.82C34.27 129.27 33.44 112.83 34.36 112.45C39.98 104.14 53.67 119.1 63.25 116.2C72.83 113.3 89.15 112.89 99.17 113.01C104.55 113.07 110.02 113.28 115.14 114.93C118.48 115.99 121.17 116.5 124.6 117.18Z"
          fill="#9B5808"
        />
        <path
          d="M85.8099 238.69C85.6299 241.44 87.6399 243.95 90.0999 245.16C92.5599 246.37 95.3899 246.52 98.1399 246.52C104.14 246.46 110.14 245.66 115.97 244.15C120.02 243.09 124.34 241.67 128.51 242.11C132.06 241.05 133.86 237.17 135.1 233.68C137.35 227.38 139.21 220.91 139.74 214.26C140.27 207.61 140.24 195.19 139.39 188.57C137.35 172.84 136.64 165.63 131.88 151.85C130.99 149.31 129.75 146.88 127.89 144.96C124.25 141.15 118.64 139.67 113.37 140.11C108.1 140.55 103.14 142.71 98.5299 145.25C96.6099 146.31 94.7499 147.44 93.0599 148.8C88.3299 152.67 85.3099 158.32 83.5999 164.2C81.8899 170.08 81.3799 176.23 80.8799 182.32C79.5799 198.2 79.3099 214.37 82.0599 230.07C82.6199 233.2 83.5399 236.49 85.8099 238.67V238.69Z"
          fill="#BE8960"
        />
        <path
          d="M103.61 41.2001C70.4699 40.3701 49.7399 53.0301 39.2199 80.8801C24.8199 117.84 37.6799 138.24 79.7499 134.45C94.7399 132.74 116.32 138.97 132.17 132.03C129.72 127.48 145.8 115.12 150.38 108.73C158.63 96.6401 157.59 79.7301 150.94 67.1601C141.66 50.1901 136.51 36.5901 104.49 41.1101L103.6 41.2001H103.61Z"
          fill="#9B5808"
        />
        <path
          d="M133.33 113.82C138.89 111.54 144.62 106.1 146.72 100.81C150.42 91.59 149.97 81.12 146.87 71.66C144.89 65.6 142.32 59.01 136.37 55.84C134.27 54.72 131.88 54.07 129.54 54.42C127.2 54.77 124.96 56.22 124.07 58.44C123.66 59.47 123.54 60.66 122.77 61.49C122 62.32 121.26 62.35 120.11 61.19C114.73 55.63 107.63 51.58 99.8901 51.4C93.8901 51.28 88.0001 53.56 82.9501 56.78C78.8101 59.38 75.3801 61.81 71.9201 67.16C67.3601 74.24 66.1501 83.04 68.1301 91.24C69.7401 97.92 76.3301 106.06 82.3101 109.42C88.6801 112.99 95.4701 116.07 102.72 117.09C106.18 117.56 109.67 117.68 113.13 117.71C115.73 117.74 118.36 117.77 120.96 117.44C125.22 116.91 129.33 115.43 133.29 113.8H133.32L133.33 113.82Z"
          fill="#FFD29F"
        />
        <path
          opacity="0.96"
          d="M96.9901 58.17C93.9401 58.41 90.9901 60.33 88.1501 62.22C81.5001 66.12 74.1401 70.58 68.2301 75.52C66.8101 80.4 66.8801 85.76 67.9101 90.82C68.7701 95.02 71.4201 98.88 74.0201 102.28C79.7901 99.47 85.5501 96.66 91.2301 93.65C98.9501 89.63 108.85 84.78 110.48 76.09C112.28 66.6 108.29 56.64 97.0001 58.14V58.17H96.9901Z"
          fill="#5C2600"
        />
        <path
          opacity="0.96"
          d="M141.93 84.25C143.53 84.58 147.7 84.52 149.29 84.04C148.99 78.45 147.96 74.4 146.9 71.3C144.98 65.71 143.74 62.02 140.01 58.14C137.97 57.37 135.87 57.31 134.3 58.05C133.24 58.55 132.26 60.24 132.14 60.83C130.69 66.42 131.7 74.93 135.39 79.9C137.08 81.64 139.56 83.77 141.95 84.25H141.92H141.93Z"
          fill="#5C2600"
        />
        <path
          d="M103.76 68.34C99.1801 68.16 94.5701 68.55 90.1301 69.94C87.9401 70.62 85.7001 71.65 84.2501 73.64C83.1601 75.12 82.5901 77.04 82.6801 78.96C82.7701 80.88 83.5401 82.71 84.7501 84.05C86.7901 86.27 89.8901 86.83 92.7001 86.5C96.1301 86.09 99.4701 84.52 102.1 82.01C103.16 81 104.14 79.82 104.76 78.43C105.32 77.13 105.59 75.71 105.79 74.29C105.91 73.52 106 72.72 105.91 71.92C105.76 70.71 105.11 69.58 104.22 68.93C103.33 68.28 102.12 68.1 101.09 68.46"
          fill="#5C2600"
        />
        <path
          d="M88.1301 66.6802C80.5301 71.0902 83.4901 81.7902 91.7101 83.4402C99.9301 85.1002 107.85 76.0502 103.68 69.7802C99.9801 64.0702 93.4801 64.3102 88.1301 66.6502V66.6802Z"
          fill="#FAF6D6"
        />
        <path
          d="M93.6799 67.3901C88.5699 70.8201 90.2799 80.3101 96.2799 81.7301C102.28 83.1501 108.05 75.4001 105 70.0201C102.31 65.1401 95.5099 63.7501 93.6799 67.3901Z"
          fill="#522E2D"
        />
        <path
          d="M135.54 63.9901C138.08 63.8101 138.2 61.3301 140.63 62.7201C141.84 63.4001 143.08 64.4301 143.88 66.3901C144.47 67.8401 144.8 69.7601 144.74 71.6501C144.68 73.5401 144.27 75.3801 143.59 76.7101C142.47 78.9001 140.75 79.4601 139.18 79.1301C137.29 78.7201 135.45 77.1501 133.98 74.6701C133.39 73.6601 135.28 75.3501 134.96 73.9601C134.63 72.6901 134.49 71.2701 134.37 69.8501C134.31 69.0801 134.25 68.2801 134.31 67.5101C134.4 66.3001 134.75 65.2001 135.26 64.5501C135.77 63.9001 136.41 63.7201 137 64.0801"
          fill="#5C2600"
        />
        <path
          d="M141.34 63.1901C145.21 67.0001 143.71 76.2601 139.51 77.7101C135.31 79.1601 131.26 71.2901 133.39 65.9101C135.28 60.9701 138.59 61.1801 141.34 63.2201V63.1901Z"
          fill="#FAF6D6"
        />
        <path
          d="M139.5 63.67C142.4 66.77 141.42 75.38 138.02 76.65C134.62 77.92 131.31 70.91 133.05 66.07C134.59 61.64 138.46 60.39 139.5 63.68V63.67Z"
          fill="#522E2D"
        />
        <path
          opacity="0.1"
          d="M71.7701 104.95C75.8801 101.22 81.6401 99.86 87.1701 99.72C90.6001 99.63 94.1501 99.96 97.1301 101.64C100.06 103.3 102.16 106.1 103.66 109.09C105.88 113.5 106.91 118.88 104.69 123.28C102.77 127.06 99.0101 130.55 94.9301 131.71C89.4001 133.25 86.0601 133.07 81.9801 131.86C77.4001 130.5 71.0101 127.81 68.5601 123.37C65.7501 118.31 67.6701 108.65 71.7801 104.95H71.7501H71.7701Z"
          fill="#FF5580"
        />
        <path
          opacity="0.1"
          d="M156.15 86.7901C154.55 85.9601 152.45 85.2501 150.77 85.1601C148.85 85.0701 146.84 85.3701 145.15 86.8201C143.49 88.2401 142.31 90.6001 141.48 93.1501C140.24 96.8801 139.65 101.49 140.92 105.21C141.98 108.43 144.11 111.39 146.42 112.36C147.66 112.89 146.3 112.36 147.25 112.48C147.49 112.18 147.69 111.89 147.9 111.62C152.9 105.83 157.21 95.7401 156.15 86.7901Z"
          fill="#FF5580"
        />
        <path
          d="M126.79 79.5701C132.61 75.5501 130.04 70.1102 123.01 71.4702C119.99 72.0302 116.77 73.7501 117.95 76.8501C119.34 79.4201 123.72 80.7201 126.41 79.7801L126.82 79.6001L126.79 79.5701Z"
          fill="#522E2D"
        />
        <path
          d="M119.93 96.4802C122.12 97.8402 123.66 98.6102 126.23 98.4602C128.42 98.3402 129.84 97.9602 131.37 96.4202"
          stroke="#522E2D"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M79.63 161.12C76.53 165.46 79.84 171.73 83.07 176.47C84.39 178.41 86.97 181.19 88.84 182.6C91.77 184.8 94.91 186.7 98.05 188.64C105.8 193.37 113.51 198.13 121.26 202.86C124.78 205.02 128.56 207.5 129.92 211.4C130.36 212.7 130.51 214.09 130.42 215.48C130.24 217.76 129.41 217.49 127.4 218.61C126.19 219.29 124.74 219.41 123.35 219.35C121.1 219.26 117.44 219.08 114.81 218.73C105.5 217.46 97.96 215.77 88.56 213.41C76.76 210.45 64.55 205.58 57.34 195.79C54.03 191.3 50.33 184.61 48.8 179.26C47.56 175 50.13 174.03 51.64 177.93C53.33 182.25 61.43 181.66 62.22 179.88C64.47 174.91 60.36 153.54 65.35 151.35C67.6 150.37 69.99 149.55 72.45 149.43C74.91 149.31 77.48 149.93 79.34 151.56C82.24 154.04 79.19 157.35 79.67 161.11H79.64L79.63 161.12Z"
          fill="#894C0A"
        />
        <path
          d="M85.6701 157.92C82.2101 162.77 82.2101 169.83 85.6701 174.68C87.1801 176.78 89.2201 178.46 91.3501 179.97C93.9801 181.86 96.7601 183.55 99.5401 185.26C107.29 189.99 115 194.75 122.75 199.48C126.27 201.64 130.05 204.12 131.41 208.02C131.85 209.32 132 210.71 131.91 212.1C131.73 214.38 130.76 216.77 128.75 217.87C127.54 218.55 126.09 218.67 124.7 218.61C122.45 218.52 120.24 217.96 118.05 217.4C108.71 215.03 99.3401 212.7 90.0801 210.01C78.3701 206.61 66.0701 202.18 58.8601 192.39C55.5501 187.9 53.5401 182.57 51.5901 177.31C50.0501 173.17 52.1201 168.38 53.1301 164.06C53.5701 162.17 54.0201 160.28 54.8201 158.53C57.0701 153.56 61.8601 150.16 66.8801 147.98C69.1301 147 71.5201 146.18 73.9801 146.06C76.4401 145.94 79.0101 146.56 80.8701 148.19C83.7701 150.67 85.2501 154.16 85.7201 157.95L85.6901 157.92H85.6701Z"
          fill="#9B5808"
        />
        <path
          d="M135.43 48.7799C129.53 42.8199 121.3 40.2599 103.91 39.9099H102.68C89.1099 41.2999 78.7399 43.9999 69.6099 48.7799H135.44H135.43Z"
          fill="#9B5808"
        />
        <path
          d="M67.4299 48C67.4299 48 70.4799 37.12 75.5299 35.49C75.8299 38.18 76.4799 40.13 76.4799 40.13L79.6999 38.3C79.6999 38.3 74.9399 44.04 90.9099 41.67C79.0799 48.26 67.4399 47.97 67.4399 47.97V48H67.4299Z"
          fill="#9B5808"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_446_371">
        <rect width="180" height="180" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SlothProfileSolo;
